<template>
  <svg width="100%"
       height="28px" style="display: block" >
    <g v-for="vente in ventes" :key="vente.key">
      <title>{{ vente.labelHover }} ({{ vente.startStringHover }} - {{
        vente.endStringHover }})</title>
      <rect
        :x="vente.x1String" y="0" :width="vente.widthString" rx="2" ry="2" height="100%"
        :stroke="aliasNiveauDispo.COULEUR_DISPO_INDISPONIBLE" stroke-width="2"
        :fill="aliasNiveauDispo.COULEUR_DISPO_INDISPONIBLE"/>
      <text
        :x="vente.xmilieuString" y="50%" dominant-baseline="central" text-anchor="middle"
        font-size="10" fill="white">{{ vente.label }}</text>
      <text
        :x="vente.x1String" y="50%" dominant-baseline="central" text-anchor="start"
        font-size="10" fill="white">&#xA0;{{ vente.startString }}</text>
      <text
        :x="vente.x2String" y="50%" dominant-baseline="central" text-anchor="end"
        font-size="10" fill="white">{{ vente.endString }}&#xA0;</text>
    </g>
  </svg>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import getRectangle from '@/services/catalogue/planningHelper';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import decorateurRectangleFacesLc from '@/services/decorateur/decorateurRectangleFacesLc';

const VenteReseauxLc = createNamespacedHelpers('venteReseauxLc');

export default {
  props: ['data', 'index'],
  data() {
    return {
      aliasNiveauDispo: niveauDispo,
    };
  },
  computed: {
    ...VenteReseauxLc.mapGetters([
      'criterePlanning',
    ]),
    selectionRect() {
      return getRectangle(this.criterePlanning,
        this.criterePlanning.selectedDateStart,
        this.criterePlanning.selectedDateEnd);
    },
    ventes() {
      const ventesArray = [];
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateEnd;
      const filtered = this.data.affectationsLc.filter(cmd =>
        dateStart <= moment(cmd.dateFin) && dateEnd >= moment(cmd.dateDebut));
      filtered.forEach(cmd => {
        const result = getRectangle(this.criterePlanning,
          moment(cmd.dateDebut),
          moment(cmd.dateFin));
        decorateurRectangleFacesLc(result, cmd, this.criterePlanning);
        ventesArray.push(result);
      });
      return ventesArray;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/recherche/planningSvg.vue